import * as React from 'react';
export const ICSvg = React.forwardRef(function ICSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3V0H2Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4v1H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h4v1H2Z',
      fill: '#EAEEF3',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M11 0v12h3a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-3Z',
      fill: '#FCD669',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5 0v12h6V0H5Z',
      fill: '#45B2E8',
    }),
  );
});
ICSvg.defaultProps = {
  width: '16',
  height: '12',
  viewBox: '0 0 16 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var IC = {
  category: 'flag',
  colorable: false,
  name: 'IC',
  svg: ICSvg,
};
